module.exports = __webpack_public_path__ + "img/not-found.4ba4a5c 1.55c4195.svg";